<template>
  <fragment>
    <tr v-if="canDispalayPromotionalPackage">
      <td scope="row" class="productForm__itemName">
          <label class="checkbox-inline">
            <input type="checkbox" :name="confectionItem.slug" :id="confectionItem.slug" v-model="isItemSelected">
          </label>
          <img class="d-none" :src="confectionItemImageUrl" :alt="confectionItem.name">
          <div>
            <label :for="confectionItem.idproducts">{{ confectionItem.name }}</label>
            <span class="price-per-item">{{ parseFloat(inputCharge).toFixed(2) }} zł / sztuka</span>
          </div>
          <a href="#" class="confectionRow__link" @click.prevent="handleModalOpen"><Icon v-tooltip="tooltipMessage" icon="info" /></a>
      </td>
      <td class="productForm__itemValue">
          <ValidationProvider
            :rules="getQuantityValidateString"
            v-slot="{ errors }"
          >
              <input
                type="number"
                :min="0"
                name="productQuantity"
                class="form-control d-none"
                v-model.number="inputQuantity"
                onfocus="this.select();"
                readonly
                @input="handleChange($event)"
                @wheel="$event.target.blur()"
              >
            <span class="text-danger error-message" v-for="(error, index) in errors" :key="index">{{ error }}</span>
          </ValidationProvider>
      </td>
      <td class="productForm__itemPrice" data-label="Suma">
        <span>{{(inputQuantity * inputCharge).toFixed(2) }} zł</span>
      </td>
    </tr>
    <confection-modal @handleModalOpen="handleModalOpen" :file-name="getFileName" :is-open="isConfectionModalOpen" :modal-type="getModalType" />
  </fragment>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { confectionModalMixin } from '../Modals/confectionModalMixin';
import ConfectionModal from '../Modals/ConfectionModal.vue';
import Icon from '../Icon.vue';
import { modalType } from '@/components/Modals/modalType';
import {
  filterOutConfectionProduct,
  filterProductsForDeliveryNumber,
} from '../../utils/confection/filters';
import {
  checkProductsIsConfectionServiceBasedOnQuantity,
  checkProductIsConfectionOne,
  checkProductIsConfectionMany,
  checkProductsIsCoupon,
} from '@/utils/categoryUtils';
import { DataLayerManager } from '@/utils/DataLayerManager';
import { confectionTooltips } from '@/utils/confection/tooltips';

const ETUI_PERSONALIZED_SLUG = 'personalizacja-nadruku-na-etui';
const ENVELOPE_PERSONALIZED_SLUG = 'personalizacja-nadruku-na-kopercie';
const MUTUALLY_EXCLUSIVE_ITEMS = {
  [ETUI_PERSONALIZED_SLUG]: {
    name: 'Personalizacja nadruku na kopercie',
    slug: ENVELOPE_PERSONALIZED_SLUG,
  },
  [ENVELOPE_PERSONALIZED_SLUG]: {
    name: 'Personalizacja nadruku na etui',
    slug: ETUI_PERSONALIZED_SLUG,
  },
};
const slugToModalType = {
  'wlozenie-kuponow-do-kopert-ozdobnych': modalType.ENVELOPE_COUPON_PUT_IN,
  'personalizacja-nadruku-na-kopercie': modalType.ENVELOPE_COUPON_PERSONALISATION,
  'wlozenie-karty-do-ozdobnego-etui': modalType.NDE_ETUI_CARD_PUT_IN,
  'personalizacja-nadruku-na-etui': modalType.NDE_ETUI_CARD_PERSONALISATION,
};

export default {
  name: 'ConfectionServiceRowForm',
  mixins: [confectionModalMixin],
  components: {
    ConfectionModal,
    Icon,
  },
  props: ['confectionItem', 'delivery_id', 'isConfectionEnabled'],
  data() {
    return {
      inputQuantity: 0,
      lastQuantity: 0,
      inputCharge: 0.00,
      isItemSelected: false,
    };
  },
  created() {
    const product = this.populateValue();
    this.inputQuantity = (product.length > 0) ? product[0].quantity : 0;
    this.lastQuantity = this.inputQuantity;
    this.inputCharge = this.confectionItem.price || 0.00;
    this.isItemSelected = !!this.inputQuantity;
    this.assertCorrectConfectionVariant();
  },
  computed: {
    ...mapState({
      currentStep: state => state.steps.currentStep,
      stepType: state => state.steps.stepType,
    }),
    isCoupon() {
      return checkProductsIsCoupon(this.$store.state.products.all.products[0]);
    },
    getDisabled() {
      return this.confectionItem.idproducts === 1000002 && this.$store.getters['cart/getUserIsGuest'];
    },
    confectionItemImageUrl() {
      return `${process.env.VUE_APP_BASE_URL}/img/PLUXEE_confection.svg`;
    },
    canDispalayPromotionalPackage() {
      // TODO: copy to glopal config

      // Karta dla Dzieci
      if (this.$store.getters.allProducts[0].idproducts === 28898 && this.confectionItem.idproducts === 1000001) {
        return false;
      }

      const promoPacketsProduct = [26, 2, 25, 1];
      const type = this.$store.getters.getType;
      if (this.confectionItem.idproducts || this.confectionItem.id !== 1000001) {
        return true;
      }

      if (promoPacketsProduct.indexOf(parseInt(type, 10)) >= 0) {
        return true;
      }
      return false;
    },
    isParentMarketingProduct() {
      return this.$store.getters.deliveriesProducts(this.delivery_id)[0].confection.some(el => el.idproducts === this.confectionItem.product_ref_id);
    },
    getParentMarketingProduct() {
      if (!this.isParentMarketingProduct) {
        return null;
      }
      const parent = this.$store.getters.deliveriesProducts(this.delivery_id)[0].confection.find(el => el.idproducts === this.confectionItem.product_ref_id);
      if (parent) {
        return parent;
      }
      return null;
    },
    getParentProductName() {
      const parent = this.getParentMarketingProduct;
      if (parent) {
        return parent.name;
      }
      return '';
    },
    getMaxNumberOfItems() {
      if (this.isCoupon) {
        return this.totalConfectionQuantityOnDeliveryPoint;
      }
      if (!this.isParentMarketingProduct) {
        return this.totalProductsQuantityOnDeliveryPoint;
      }
      const parent = this.$store.getters['delivery/getValue'](Number(this.delivery_id), this.confectionItem.product_ref_id)[0];
      if (parent) {
        return parent.quantity;
      }
      return 0;
    },
    totalProductsQuantityOnDeliveryPoint() {
      const { productsWithoutConfection } = filterOutConfectionProduct(this.$store.state.delivery.products);
      const productsWithoutDeliveryAddress = productsWithoutConfection.filter(product => product.id !== 1000002);
      const filteredOutPromoPack = productsWithoutDeliveryAddress.filter(product => product.id !== 1000001);
      const productsForDeliveryNumber = filterProductsForDeliveryNumber(filteredOutPromoPack, this.delivery_id);

      if (productsForDeliveryNumber.length > 1) {
        return _.sumBy(productsForDeliveryNumber, product => product.quantity);
      }

      if (productsForDeliveryNumber.length === 1) {
        return productsForDeliveryNumber[0].quantity;
      }
      return 0;
    },
    totalConfectionQuantityOnDeliveryPoint() {
      const items = this.$store.state.delivery.products;
      const confection = items.filter(
        item => (
          item.product_category === 'MKT_ISS'
          && item.iddelivery === this.delivery_id
        ),
      );
      return _.sumBy(confection, item => item.quantity);
    },
    getModalType() {
      return slugToModalType[this.confectionItem.slug];
    },
    getFileName() {
      const filesName = {
        EC_ISS: 'Zalacznik_do_konfekcji_kart–wzor.xlsx',
        V_ISS: 'Zalacznik_do_konfekcji_kuponow–wzor.xlsx',
      };
      const productCategory = this.$store.state.products.all.products[0].product_category;

      if (filesName[productCategory]) {
        return filesName[productCategory];
      }
      return 'Zalacznik_do_konfekcji_kart–wzor.xlsx';
    },
    tooltipMessage() {
      return confectionTooltips[this.confectionItem.slug] || '';
    },
    currentStep() {
      return this.$store.state.steps.currentStep;
    },
    isVisible() {
      return true;
    },
    getQuantityValidateString() {
      const baseValidator = this.isCoupon ? 'confectionServiceProductNumber' : 'confectionServiceProduct';
      let rules = `${baseValidator}:${this.getMaxNumberOfItems},${this.getParentProductName}`;
      const { slug } = this.confectionItem;
      if ([ENVELOPE_PERSONALIZED_SLUG, ETUI_PERSONALIZED_SLUG].includes(slug)) {
        const otherProduct = MUTUALLY_EXCLUSIVE_ITEMS[slug];
        const otherProductQuantity = this.getQuantityBySlug(otherProduct.slug);
        rules += `|mutuallyExclusive:${otherProductQuantity},${otherProduct.name}`;
      }
      return rules;
    },
    isMoreThanOneDistinctProduct() {
      if (!checkProductsIsConfectionServiceBasedOnQuantity(this.confectionItem)) {
        return false;
      }
      const { productsWithoutConfection } = filterOutConfectionProduct(this.$store.state.delivery.products);
      const productsForDeliveryNumber = filterProductsForDeliveryNumber(productsWithoutConfection, this.delivery_id);
      return productsForDeliveryNumber.filter(product => product.quantity > 0).length > 1;
    },
    getCorrespondingConfection() {
      if (!checkProductsIsConfectionServiceBasedOnQuantity(this.confectionItem)) {
        return null;
      }
      const correspondingConfection = this.$store.getters.allProducts[0].confectionService
        .find(el => el.slug === this.confectionItem.slug && el.idproducts !== this.confectionItem.idproducts);
      if (correspondingConfection) {
        return correspondingConfection;
      }
      return null;
    },
  },
  methods: {
    getQuantityBySlug(slug) {
      const item = this.$store.getters['delivery/getValueBySlug'](Number(this.delivery_id), slug)[0];
      return item ? item.quantity : 0;
    },
    handleChange(e) {
      let quantity = e.target.name === 'productQuantity' ? e.target.value : this.inputQuantity;
      if (quantity === '') {
        quantity = 0;
        this.inputQuantity = 0;
      }
      const newProduct = {
        id: this.confectionItem.idproducts || this.confectionItem.id,
        quantity: parseFloat(quantity),
        price: parseFloat(this.inputCharge),
        name: this.confectionItem.name,
        slug: this.confectionItem.slug,
        iddelivery: parseFloat(this.$props.delivery_id),
        product_category: this.confectionItem.product_category,
        analyticsData: this.confectionItem.analyticsData,
      };
      this.product = newProduct;
      this.$store.dispatch('delivery/addProductToCart', newProduct);

      if (this.lastQuantity > this.inputQuantity) {
        const quantityDiff = this.lastQuantity - this.inputQuantity;
        DataLayerManager.pushRemoveCartEvent(newProduct, quantityDiff);
      } else if (this.lastQuantity < this.inputQuantity) {
        const quantityDiff = this.inputQuantity - this.lastQuantity;
        DataLayerManager.pushAddToCartEvent(newProduct, quantityDiff);
      }

      this.lastQuantity = this.inputQuantity;
    },
    removeItem() {
      const removedProduct = this.getProductFromDelivery();
      this.$store.dispatch('delivery/deleteProductFromCart', [this.product, this.$props.delivery_id]);
      DataLayerManager.pushRemoveCartEvent(this.product, removedProduct[0].quantity);
    },
    getProductFromDelivery() {
      return this.$store.getters['delivery/getValue'](Number(this.$props.delivery_id), this.product.idproducts);
    },
    populateValue() {
      return this.$store.getters['delivery/getValue'](Number(this.delivery_id), this.confectionItem.idproducts);
    },
    resetConfectionAmount() {
      // this.$store.dispatch('confection/handleConfectionElementSelection', '');
      this.removeItem();
      this.$forceUpdate();
      this.inputQuantity = 0;
    },
    assertCorrectConfectionVariant() {
      if (!checkProductsIsConfectionServiceBasedOnQuantity(this.confectionItem)) {
        return;
      }
      const correspondingConfection = this.getCorrespondingConfection;
      if ((this.isMoreThanOneDistinctProduct && checkProductIsConfectionOne(this.confectionItem))
        || (!this.isMoreThanOneDistinctProduct && checkProductIsConfectionMany(this.confectionItem))) {
        const removedProduct = this.getProductFromDelivery();
        this.$store.dispatch('delivery/deleteProductFromCart', [{ id: this.confectionItem.idproducts }, this.$props.delivery_id]);
        if (this.product) {
          DataLayerManager.pushRemoveCartEvent(this.product, removedProduct[0].quantity);
        }
        if (this.inputQuantity) {
          const newProduct = {
            id: correspondingConfection.idproducts,
            quantity: parseFloat(this.inputQuantity),
            price: parseFloat(correspondingConfection.price),
            name: correspondingConfection.name,
            iddelivery: parseFloat(this.$props.delivery_id),
            product_category: correspondingConfection.product_category,
            analyticsData: correspondingConfection.analyticsData,
          };
          this.$store.dispatch('delivery/addProductToCart', newProduct);
          DataLayerManager.pushAddToCartEvent(newProduct);
          this.product = newProduct;
        }
        this.confectionItem = correspondingConfection;
        this.inputCharge = correspondingConfection.price || 0.00;
      }
    },
    setQuantity(quantity) {
      this.inputQuantity = quantity;
      this.handleChange({
        target: {
          name: 'productQuantity',
          value: quantity,
        },
      });
    },
  },
  watch: {
    totalProductsQuantityOnDeliveryPoint(val) {
      if (!this.isItemSelected || this.isCoupon) return;
      this.setQuantity(val);
    },
    totalConfectionQuantityOnDeliveryPoint(val) {
      if (!this.isItemSelected || !this.isCoupon) return;
      this.setQuantity(val);
    },
    isItemSelected(val) {
      if (!val) {
        this.setQuantity(0);
      } else if (this.isCoupon) {
        this.setQuantity(this.totalConfectionQuantityOnDeliveryPoint);
      } else {
        this.setQuantity(this.totalProductsQuantityOnDeliveryPoint);
      }
      this.$emit('item-select', val);
    },
    inputQuantity(val) {
      this.isItemSelected = val > 0;
      this.$emit('item-select', val > 0);
    },
    isConfectionEnabled() {
      /*
      * Fired when confection checkbox go unselected
      * */
      if (!this.isConfectionEnabled) {
        this.resetConfectionAmount();
      }
    },
    isMoreThanOneDistinctProduct() {
      this.assertCorrectConfectionVariant();
    },
    confectionItem() {
      if (this.currentStep === this.stepType.START) {
        this.assertCorrectConfectionVariant();
      }
    },
  },

};
</script>

<style scoped>
  label.subsection {
    font-size: 0.9em;
    padding-left: 0.5em;
  }
</style>
